'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_ju_IllformedLocaleException__T__I__($thiz, s, errorIndex) {
  $j_java$002elang$002e$002dObject.$ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, (s + ((errorIndex < 0) ? "" : ((" [at index " + errorIndex) + "]"))), null, true, true);
  return $thiz;
}
export { $ct_ju_IllformedLocaleException__T__I__ as $ct_ju_IllformedLocaleException__T__I__ };
function $ct_ju_IllformedLocaleException__T__($thiz, s) {
  $ct_ju_IllformedLocaleException__T__I__($thiz, s, (-1));
  return $thiz;
}
export { $ct_ju_IllformedLocaleException__T__ as $ct_ju_IllformedLocaleException__T__ };
class $c_ju_IllformedLocaleException extends $j_java$002elang$002e$002dObject.$c_jl_RuntimeException {
}
export { $c_ju_IllformedLocaleException as $c_ju_IllformedLocaleException };
var $d_ju_IllformedLocaleException = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_IllformedLocaleException, "java.util.IllformedLocaleException", ({
  n9: 1,
  R: 1,
  Q: 1,
  H: 1,
  a: 1
}));
export { $d_ju_IllformedLocaleException as $d_ju_IllformedLocaleException };
